import React from "react";
import { motion } from "framer-motion";
import { FaBuilding, FaCheck, FaEnvelope } from "react-icons/fa";

export default function CompanyCard({ company, index, onSelect }) {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: index * 0.08 }}
      whileHover={{ y: -10, scale: 1.03 }}
      whileTap={{ scale: 0.97 }}
      onClick={() => onSelect(company)}
      className="company-card"
    >
      <div className="card-glow"></div>
      <div className="company-avatar">
        <FaBuilding size={38} />
      </div>
      <h3>{company.name}</h3>
      <p>
        <FaEnvelope style={{ marginRight: 6 }} /> Email:{" "}
        {company.email || "N/A"}
      </p>
      <div className="select-hint">
        <FaCheck size={14} /> Click to select
      </div>
    </motion.div>
  );
}
